/*
 * @Author: zhangyuan zhangyuan@cheyipai.com
 * @Date: 2021-11-30 14:36:37
 * @LastEditors: zhangyuan your_email
 * @LastEditTime: 2024-12-05 17:30:47
 * @FilePath: /report-template/src/service/axios.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Axios from 'axios';

const request = {
    method: 'get',
    url: '',
    header: {},
    data: {}
};

const axios = (opts: any)=> {
    return new Promise((resolve, reject) => {
        let data = opts.method.toLocaleLowerCase() === 'get' ? 'params' : 'data';
        let config = {
            headers: Object.assign(request.header, opts.header),
            timeout: opts.timeout || 30000,
            method: opts.method || request.method,
            url: opts.url || request.url,
            [data]: opts.data || request.data
        }
        // console.log(config);
        Axios(config).then((response) => {
            if(config.url.indexOf('_getreportbannerphotoinfo') > -1){
                if (Number(response.status) === 200) {
                    resolve(response.data);
                } else {
                    reject(response);
                }
                return
            }
            if(opts.resHasData) {
                resolve(response.data);
            }
            if (Number(response.status) === 200) {
                resolve(response.data.data);
            } else {
                reject(response);
            }
        }).catch((response) => {
            reject(response);
        });
    });
};

export default axios;
